// Extracts the route name from the path name after the slash
// Examples: '/' returns '', '/about' returns 'about'
export const getRouteName = (path: string) => {
  if (!path) return ''

  const pathArray = path.split('/')
  return pathArray.length > 1 ? pathArray[1] : ''
}
